import Socket from 'sockjs-client';
import Stomp from 'stompjs';
import axios from 'axios';
import { USER_NAME_STORAGE_KEY } from './components/UserNameModal';

export function getInitiativeName() {
  return window.location.pathname.substring(1);
}

const PORT = process.env.REACT_APP_BACKEND_PORT || '8082';
const BASE_URL = `https://masterplan.space:${PORT}`;
export const SOCKET_URL = `${BASE_URL}/openchangebeta`;
export const MESSAGE_LIST_TOPIC = `/topic/messages/${getInitiativeName()}`
export const MESSAGE_SUBMIT_TOPIC = '/app/submit';
export const USER_VIEWS = '/app/userviews/'
export const UNREAD_MESSAGES_TOPIC = '/topic/userviews/'
export const ON_LOAD_TOPIC = '/app/onload';
export const SUMMARY_VOTES = `/topic/votes/${getInitiativeName()}`

export function getSocketCliet() {
  const socket = new Socket(SOCKET_URL);
  const client = Stomp.over(socket);
  return client;
};

export function getUserUnreadMessageTopic() {
  return `${UNREAD_MESSAGES_TOPIC}${localStorage.getItem(USER_NAME_STORAGE_KEY)}/${getInitiativeName()}`
}

const http = axios.create({
  baseURL: BASE_URL,
});

export function deleteMessage(id) {
  return http.delete(`${BASE_URL}/message/${id}`);
}

export function updateMessageChannel(id, channel) {
  return http.put(`${BASE_URL}/message/${id}/${channel}`);
}

export function toggleMessageType(id) {
  return http.put(`${BASE_URL}/message/toggle/${id}`);
}

export function voteForSummary(summaryId, vote) {
  return http.post(`${BASE_URL}/vote`, {
    vote,
    summaryId,
    user: localStorage.getItem(USER_NAME_STORAGE_KEY)
  })
}

export function authorize(user, email){
  return http.post(`${BASE_URL}/authorized`, {
    username: user,
    workspaceUrl: getInitiativeName(),
    email : email
  })
}

export function newUserJoined() {

  return http.post(`${BASE_URL}/newuser`, {
    user: localStorage.getItem(USER_NAME_STORAGE_KEY),
    initiative: getInitiativeName()
  })
}

export function workspaceLoaded() {
  return http.post(`${BASE_URL}/workspace_loaded`, {
    user: localStorage.getItem(USER_NAME_STORAGE_KEY) || '.anonymous',
    initiative: getInitiativeName()
  })
}

export function registerPushSubscription(pushSubcription) {
  const data = new FormData();
  data.set('subscriptionJson', JSON.stringify(pushSubcription));
  data.set('username', localStorage.getItem(USER_NAME_STORAGE_KEY))
  return http.post(`${BASE_URL}/register`, data)
}


